import type { ReactNode } from 'react'
import { Label } from '@/components/ui/label'

/** Labelled read-only value row used across the settings sections. */
export function FieldRow({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label className="text-muted-foreground text-xs font-normal">{label}</Label>
      <div className="text-sm">{children}</div>
    </div>
  )
}
